export default __webpack_public_path__ + "static/media/placempus_jonas_bienz_website_still.06e3ab95.jpg";